export const solutionLinkAddedString = "Solution is linked.";
export const appDisplayName = "My Settings";
export const passwordChangeQueryParam = "passwordChanged";
export const mergeSuccessQueryParam = "mergeSuccess";

// string constants for GTM
export const appVersion = "1";
export const liveEnv = "live";
